/* Copyright (c) 2017 Backpack Health LLC */
/* global IS_ANDROID_BUILD */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import { AppHeaderScrollableTextWithLanguage } from '../../components/appNav/AppHeaderScrollable';
import Card, { CardSection } from '../../components/card/Card';
import InputWithLabel from '../../components/InputWithLabel';

import { validateEmail } from '../../../utilities/Validators';
import PasswordService from '../../../apiServices/PasswordService';
import ContentWrapper from '../../components/ContentWrapper';

class ForgotPassword extends React.Component {

  constructor(props) {
    super(props);

    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.onFocus = this.onFocus.bind(this);

    this.state = {
      email: props.email,
      isEmailValid: validateEmail(props.email),
      errorMessage: '',
    };
  }

  onChangeEmail(e) {
    const value = e.target.value;
    this.setState({
      email: value,
      isEmailValid: validateEmail(value),
    });
  }

  onFocus() {
    this.setState({ errorMessage: '' });
  }

  submitForm(e) {
    e.preventDefault();

    if (!this.state.isEmailValid) {
      this.setState({
        errorMessage: <FormattedMessage id="error.email-validator.invalid-email.message" />,
      });
      return;
    }

    PasswordService.forgot(this.state.email, () => {
      this.props.updateEmail(this.state.email);
      this.props.goToCheckInbox();
    });
  }

  render() {
    return (
      <div>
        <ScrollAwareContext>
          <ScrollAwareAppNavStep
            next={this.submitForm}
            submitDisabled={this.state.email.length === 0}
            goBack={this.props.goBack}
            color="white"
          />

          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableTextWithLanguage
                id="forgotPwd.title.text"
                allowLanguageToggle={!IS_ANDROID_BUILD}
              />
              <ContentWrapper>
                <Card>
                  <CardSection>
                    <form onSubmit={this.submitForm}>
                      <div>
                        <InputWithLabel
                          value={this.state.email}
                          onChange={this.onChangeEmail}
                          onFocus={this.onFocus}
                          type="email"
                          label={<FormattedMessage id="forgotPwd.email.field.label" />}
                          isInvalid={!!this.state.errorMessage}
                          invalidHint={this.state.errorMessage}
                          name="email"
                        />
                      </div>
                      <input type="submit" style={{ visibility: 'hidden' }} />
                    </form>
                  </CardSection>
                </Card>
              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}
ForgotPassword.propTypes = {
  email: PropTypes.string,
  goBack: PropTypes.func,
  goToCheckInbox: PropTypes.func,
  updateEmail: PropTypes.func,
};

export default ForgotPassword;
